// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.71741L2 5.92575V21.5001L7.5 19.2328V2.71741Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 18.9097L11.25 19.9432V16.75C11.25 14.3035 12.5516 12.161 14.5 10.9771V5.09051L9.5 2.1377V18.9097Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2.50012V11.3123C20.8805 10.4875 19.4972 10 18 10C17.4845 10 16.9824 10.0578 16.5 10.1673V4.76744L22 2.50012Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 23.7013C17.9326 23.6564 17.8649 23.6118 17.7971 23.5672C17.6129 23.4459 17.4286 23.3246 17.2505 23.1949C17.1356 23.1113 16.9752 22.9906 16.7845 22.836C16.4045 22.5281 15.8963 22.0799 15.3852 21.5179C14.3903 20.4239 13.25 18.7512 13.25 16.75C13.25 14.1266 15.3766 12 18 12C20.6234 12 22.75 14.1266 22.75 16.75C22.75 18.7512 21.6097 20.4239 20.6148 21.5179C20.1037 22.0799 19.5955 22.5281 19.2155 22.836C19.0248 22.9906 18.8644 23.1113 18.7495 23.1949C18.5713 23.3246 18.387 23.4459 18.2029 23.5672C18.1351 23.6118 18.0674 23.6564 18 23.7013ZM19.25 16H16.75V18H19.25V16Z"}}]};

const MapLocationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-location-filled',
    ref,
    icon: element,
  },
));

MapLocationFilledIcon.displayName = 'MapLocationFilledIcon';

export default MapLocationFilledIcon;
